import GlimpseCard from '../../components/card/card.component'
import Button from 'components/button/button'
import { getArticle } from 'utills/grammar'
import CardTitle from 'components/card/card-title'
import CardContent from 'components/card/card-content'
import CardLayout from 'components/card/card-layout'
import GlimpseEducationSection from '../../components/Education-section/education-section.component'
import GlimpseCareerTrends from '../../components/career-trends/career-trends.component'
import GlimpseImpactCard from '../../components/imapct-card/impact-card.component'
import GlimpseScrollCard from '../../components/scroll-cards/scroll-card.component'
import { useEffect, useRef, useState } from 'react'
import VideoPlayer from 'components/video-streaming-onboard/video-player.component'
import {
  IContributionCard,
  IExpertVoiceCard,
  IEducationCard,
  IDayInLIfeCard,
  IDidYouKnowsCard,
  IProsConsCard,
  ICareerTrendCard,
  IImpactCard,
} from 'interfaces/CareerInfoInterface'
import {
  IDeeperDiveQuiz,
  IGreatWork,
  IQuiz,
  IReprioritise,
  ISalary,
} from 'interfaces/CareerInterface'
import BarChart from 'components/charts/bar-chart.component'
import ReactPlayer from 'react-player'

export const ContributionCard: React.FC<IContributionCard> = ({
  contribution_url,
  from,
  careerName,
}) => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex justify-between items-start pb-2 border-b border-[#C7C7C7] mb-8">
        <h2 className="text-4xl font-semibold leading-10 text-brand">
          Contribution
        </h2>
        {from === 'DeeperDive' && (
          <p className="text-sm font-normal leading-5 text-gray-dark text-right max-w-[340px]">
            Words {getArticle(careerName || 'engineer')}{' '}
            {careerName ? careerName.toLowerCase() : 'engineer'} might use to
            describe their greatest contribution in this career.
          </p>
        )}
      </div>
      <div className="flex items-center justify-center w-full overflow-hidden rounded border border-gray-light bg-white shadow-subtle p-4">
        <img
          src={
            contribution_url ? contribution_url : '/assets/images/NoPreview.jpg'
          }
          className="max-w-[90%] max-h-[80%] object-contain scale-110 translate-y-[5%]"
          alt="Contribution"
        />
      </div>
    </div>
  )
}
export const ExpertVoices: React.FC<IExpertVoiceCard> = ({
  expertVoiceInfo,
  deeperDiveClass,
  onVideoEnded,
  onVideoStarted,
  onProgress,
  onPaused,
  onSeek,
  selectedVideo,
  videoSelected,
  thumbnail,
  from,
}) => {
  const videoRef = useRef<ReactPlayer>(null)

  if (from === 'DeeperDive') {
    return (
      <CardLayout>
        <CardTitle
          title="Expert Voices"
          subtitle="Revisit an expert you've already met. Consider what resonates now that you've come this far."
        >
          {expertVoiceInfo.length > 1 && (
            <div className="flex gap-2 mt-4">
              {expertVoiceInfo.map((item, index) => (
                <div
                  key={index}
                  onClick={() => videoSelected(item)}
                  className={`${
                    selectedVideo === item.expert_voice.voice_url
                      ? 'opacity-100 border-2 border-dark-blue'
                      : 'opacity-50'
                  } rounded-md cursor-pointer overflow-hidden relative`}
                >
                  {item.deeper_dive_status === 'completed' && (
                    <span className="absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                      <img
                        src="/assets/icons/completed_videos-tick.svg"
                        alt="tick"
                      />
                    </span>
                  )}
                  <img
                    src={
                      item.expert_voice.voice_thumbnail
                        ? item.expert_voice.voice_thumbnail
                        : '/assets/images/NoPreview.jpg'
                    }
                    alt="Expert"
                    className={`w-[50px] h-[50px] object-cover ${
                      item.deeper_dive_status === 'completed'
                        ? 'opacity-30'
                        : ''
                    }`}
                  />
                </div>
              ))}
            </div>
          )}
        </CardTitle>
        <div
          className="w-[233px] min-w-[233px] h-[412px] rounded border border-gray-light overflow-hidden relative group shadow-subtle"
          onContextMenu={e => e.preventDefault()}
        >
          <ReactPlayer
            ref={videoRef}
            url={selectedVideo as string}
            playing={false}
            controls
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload',
                },
              },
            }}
            width="100%"
            height="100%"
            light={thumbnail}
            onStart={onVideoStarted}
            onEnded={onVideoEnded}
            onProgress={onProgress}
            onPause={onPaused}
            onSeek={onSeek}
          />
          <button
            onClick={() =>
              videoRef.current?.getInternalPlayer()?.requestFullscreen()
            }
            className="hidden sm:flex absolute right-[3rem] bottom-[30px] z-10 border-none rounded p-1 w-8 h-8 items-center justify-center opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 ease-in-out"
            aria-label="Fullscreen"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="stroke-white"
            >
              <path
                d="M14 10L20 4M20 4H15.5M20 4V8.5M4 4L10 10M4 4V8.5M4 4H8.5M14 14L20 20M20 20V15.5M20 20H15.5M10 14L4 20M4 20H8.5M4 20L4 15.5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </CardLayout>
    )
  }

  return (
    <GlimpseCard
      title="Expert Voices"
      subtitle=""
      childrenClass="h-full flex justify-center items-center"
      subtitleClass="text-sm mt-1"
    >
      <div className="flex items-center justify-center gap-4 ">
        {expertVoiceInfo.length > 1 && (
          <div className="flex flex-col justify-center ">
            {expertVoiceInfo.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() => videoSelected(item)}
                  className={` ${
                    selectedVideo === item.expert_voice.voice_url
                      ? 'opacity-1 border-2 border-headerBlue p-1'
                      : 'p-1'
                  }  block mb-1 rounded-md ${
                    item.deeper_dive_status === 'completed' && 'relative'
                  }`}
                >
                  {item.deeper_dive_status === 'completed' && (
                    <span className="absolute z-10 top-[50px] left-[20px] md:top-[35px] md:left-[15px]">
                      <img
                        src="/assets/icons/completed_videos-tick.svg"
                        alt="tick"
                      />
                    </span>
                  )}
                  <img
                    src={
                      item.expert_voice.voice_thumbnail
                        ? item.expert_voice.voice_thumbnail
                        : '/assets/images/NoPreview.jpg'
                    }
                    alt="Contribution"
                    className={`max-w-[62px] max-h-[110px] md:max-h-[82px] ${
                      item.deeper_dive_status === 'completed'
                        ? 'opacity-30'
                        : 'opacity-1'
                    }`}
                  />
                </div>
              )
            })}
          </div>
        )}
        {selectedVideo !== null && (
          <div className="relative w-full h-full group">
            <ReactPlayer
              ref={videoRef}
              url={selectedVideo}
              playing={false}
              controls
              config={{
                file: {
                  attributes: {
                    controlsList: 'nodownload',
                  },
                },
              }}
              width="100%"
              height="100%"
              light={thumbnail}
              className={deeperDiveClass ? '!h-[300px] !w-[180px]' : ''}
              onStart={onVideoStarted}
              onEnded={onVideoEnded}
              onProgress={onProgress}
              onPause={onPaused}
              onSeek={onSeek}
            />
            <button
              onClick={() =>
                videoRef.current?.getInternalPlayer()?.requestFullscreen()
              }
              className="hidden sm:flex absolute right-[3rem] bottom-[30px] z-10 border-none rounded p-1 w-8 h-8 items-center justify-center opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 ease-in-out"
              aria-label="Fullscreen"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-white"
              >
                <path
                  d="M14 10L20 4M20 4H15.5M20 4V8.5M4 4L10 10M4 4V8.5M4 4H8.5M14 14L20 20M20 20V15.5M20 20H15.5M10 14L4 20M4 20H8.5M4 20L4 15.5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </GlimpseCard>
  )
}
export const EducationCard: React.FC<IEducationCard> = ({
  education,
  pageNumber,
  setPageNumber,
  from,
  checkNextEnable,
}) => {
  useEffect(() => {
    if (window.innerWidth >= 768) {
      checkNextEnable(true)
    }
  }, [window.innerWidth])

  useEffect(() => {
    if (from === 'DeeperDive') checkNextEnable(true)
  }, [from])

  if (from === 'DeeperDive') {
    const sortedEdu = [...education].sort((a, b) => a.order - b.order)

    return (
      <div className="flex flex-col h-full px-2">
        <div className="flex justify-between items-center pb-2 border-b border-[#C7C7C7]">
          <h2 className="text-4xl font-semibold leading-10 text-brand">
            Education
          </h2>
          <p className="text-sm font-normal leading-5 text-gray-dark max-w-[320px]">
            Required and recommended education for this career.
          </p>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <div
            className={`grid w-full gap-8 ${
              sortedEdu.length > 4 ? 'grid-cols-4' : `grid-cols-${sortedEdu.length}`
            }`}
          >
            {sortedEdu.slice(0, 8).map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center gap-2"
              >
                <div className="w-[80px] h-[80px] rounded-full border border-gray-light bg-white p-2 flex items-center justify-center shadow-subtle">
                  <img
                    src={
                      item.label
                        ? `/assets/icons/${item.label.replaceAll(' ', '_')}.png`
                        : '/assets/icons/EducationPlaceholder.png'
                    }
                    alt={item.label}
                    className="w-full h-full object-contain"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null
                      currentTarget.src = '/assets/icons/Certification.png'
                    }}
                  />
                </div>
                <p className="text-sm font-semibold text-gray-dark leading-5">
                  {item.title}
                </p>
                <p className="text-xs font-normal leading-4 capitalize text-black-50">
                  {item.type}
                </p>
                <p className="text-xs font-normal leading-4 text-black-50">
                  {item.duration ? Math.round(Number(item.duration)) : ''}{' '}
                  {item.unit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {pageNumber && (
        <GlimpseCard
          title="Education"
          subtitle=""
          subtitleClass="text-[14px] sm:text-sm"
          className="flex lg:hidden min-h-[416px]"
          childrenClass="h-full flex justify-center items-center"
        >
          <div className="flex items-center justify-center h-[280px] ">
            <GlimpseEducationSection
              image={
                education[pageNumber.education].label
                  ? `/assets/icons/${education[
                      pageNumber.education
                    ].title.replaceAll(' ', '_')}.png`
                  : '/assets/icons/EducationPlaceholder.png'
              }
              label={education[pageNumber.education].label}
              description={education[pageNumber.education].type}
              duration={education[pageNumber.education].duration}
              className="text-center"
            />
          </div>
          <div className="relative bottom-0 flex justify-between">
            <div
              className="absolute right-[11.5rem]"
              hidden={pageNumber.education === 0}
              onClick={() =>
                setPageNumber((prevPageNumber: { education: number }) => ({
                  ...prevPageNumber,
                  education: prevPageNumber.education - 1,
                }))
              }
            >
              <svg
                width={35}
                height={35}
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="17.5"
                  cy="17.5"
                  r="16.5"
                  transform="rotate(-180 17.5 17.5)"
                  stroke="#56686F"
                  strokeWidth={2}
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.3323 18.3306L20.1311 27.6585C20.5606 28.1138 21.2571 28.1138 21.6866 27.6585C22.1045 27.2032 22.1045 26.4771 21.6866 26.0218L13.6539 17.5062L21.6866 8.99048C22.1045 8.53516 22.1045 7.79681 21.6866 7.34149C21.2571 6.88617 20.5606 6.88617 20.1311 7.34149L11.3207 16.6817C10.8912 17.137 10.8912 17.8753 11.3323 18.3306Z"
                  fill="#56686F"
                />
              </svg>
            </div>
            <div className="absolute left-[3rem] top-[10.5rem]">
              {pageNumber.education + 1}/{education?.length}
            </div>
            <div
              className="absolute right-0 left-[40px]"
              hidden={
                pageNumber.education === (education?.length as number) - 1
              }
              onClick={() => {
                setPageNumber((prevPageNumber: { education: number }) => ({
                  ...prevPageNumber,
                  education: prevPageNumber.education + 1,
                }))
                checkNextEnable(
                  pageNumber.education >= education?.length - 2 ? true : false,
                )
              }}
            >
              <svg
                width={35}
                height={35}
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="17.5"
                  cy="17.5"
                  r="16.5"
                  stroke="#56686F"
                  strokeWidth={2}
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23.6677 16.6694L14.8689 7.34149C14.4394 6.88617 13.7429 6.88617 13.3134 7.34149C12.8955 7.79681 12.8955 8.52285 13.3134 8.97817L21.3461 17.4938L13.3134 26.0095C12.8955 26.4648 12.8955 27.2032 13.3134 27.6585C13.7429 28.1138 14.4394 28.1138 14.8689 27.6585L23.6793 18.3183C24.1088 17.863 24.1088 17.1247 23.6677 16.6694Z"
                  fill="#56686F"
                />
              </svg>
            </div>
          </div>
        </GlimpseCard>
      )}

      <GlimpseCard
        title="Education"
        className={`${pageNumber ? 'hidden lg:flex' : ''}`}
        childrenClass="flex h-full justify-center items-center overflow-hidden overflow-y-scroll no-scrollbar"
        subtitle=""
      >
        <div className="flex justify-center text-center sm:py-8 xl:py-0 h-full">
          <div className="flex flex-wrap gap-3 justify-center items-center">
            {education
              ?.sort((a, b) => a.order - b.order)
              .map((item, index) => (
                <GlimpseEducationSection
                  key={index}
                  className="w-[120px] h-[150px]"
                  title={item.title}
                  label={item.label}
                  description={item.type}
                  duration={item.duration}
                  image={
                    item.label
                      ? `/assets/icons/${item.label.replaceAll(' ', '_')}.png`
                      : '/assets/icons/EducationPlaceholder.png'
                  }
                  unit={item.unit}
                />
              ))}
          </div>
        </div>
      </GlimpseCard>
    </>
  )
}

export const DayinLifeCard: React.FC<IDayInLIfeCard> = ({
  daysInLifeInfo,
  pageNumber,
  setPageNumber,
  from,
  checkNextEnable,
}) => {
  useEffect(() => {
    if (from === 'DeeperDive') checkNextEnable(true)
  }, [from])

  if (from === 'DeeperDive') {
    return (
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center pb-2 border-b border-[#C7C7C7] mb-8">
          <h2 className="text-4xl font-semibold leading-10 text-brand">
            Day In The Life
          </h2>
          <p className="text-sm font-normal leading-5 text-gray-dark">
            Typical daily tasks
          </p>
        </div>
        <div className="grid grid-cols-3 gap-x-4 gap-y-6 flex-1 content-center">
          {daysInLifeInfo?.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <img
                src={item.image_url}
                alt={item.title}
                className="w-[70px] h-[70px] shrink-0 rounded-full border border-gray-light mb-1.5"
              />
              <p className="text-sm font-semibold text-gray-dark leading-5 text-center">
                {item.title}
              </p>
              <p className="text-xs font-normal leading-4 text-center text-black-50">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <>
      <GlimpseCard
        title="Day in the Life"
        className="relative hidden overflow-hidden lg:flex "
        childrenClass="h-full flex justify-center"
        subtitle=""
        subtitleClass="text-sm mt-1"
      >
        <div className="hidden lg:flex p-[100px] lg:px-[15px] lg:py-0 lg:justify-center lg:items-center">
          <div
            className="absolute left-2 cursor-pointer top-[50%] z-10"
            hidden={pageNumber.dayInLife === 0}
            onClick={() => {
              setPageNumber((prevPageNumber: { dayInLife: number }) => ({
                ...prevPageNumber,
                dayInLife: prevPageNumber.dayInLife - 3,
              }))
            }}
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                transform="rotate(-180 17.5 17.5)"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3323 18.3306L20.1311 27.6585C20.5606 28.1138 21.2571 28.1138 21.6866 27.6585C22.1045 27.2032 22.1045 26.4771 21.6866 26.0218L13.6539 17.5062L21.6866 8.99048C22.1045 8.53516 22.1045 7.79681 21.6866 7.34149C21.2571 6.88617 20.5606 6.88617 20.1311 7.34149L11.3207 16.6817C10.8912 17.137 10.8912 17.8753 11.3323 18.3306Z"
                fill="#56686F"
              />
            </svg>
          </div>
          <div className="flex ">
            {daysInLifeInfo
              ?.slice(pageNumber.dayInLife, pageNumber.dayInLife + 3)
              ?.map((item, index) => (
                <div
                  key={index}
                  className={`relative ${
                    pageNumber?.dayInLife === 0
                      ? `${
                          index % 2 === 0
                            ? `${index === 2 ? 'top-[38px]' : 'top-[25px]'}  `
                            : 'bottom-[20px]'
                        } `
                      : `${index % 2 !== 0 ? 'top-[35px]' : 'bottom-[20px]'} ${
                          index === 2 && 'top-0'
                        } `
                  }pr-[15px] ${
                    pageNumber.dayInLife === 0 ? 'first:pl-0' : 'first:pl-6'
                  }`}
                >
                  <div className="flex flex-row min-w-[170px] min-h-[185px] justify-center text-center">
                    <GlimpseScrollCard
                      image={item.image_url}
                      title={item.title}
                      subtitle={item.description}
                    />
                  </div>
                </div>
              ))}
          </div>

          <div
            className="absolute right-2 cursor-pointer top-[50%] "
            hidden={
              pageNumber?.dayInLife === (daysInLifeInfo?.length as number) - 3
            }
            onClick={async () => {
              await setPageNumber((prevPageNumber: { dayInLife: number }) => ({
                ...prevPageNumber,
                dayInLife: prevPageNumber.dayInLife + 3,
              }))
              checkNextEnable(true)
            }}
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6677 16.6694L14.8689 7.34149C14.4394 6.88617 13.7429 6.88617 13.3134 7.34149C12.8955 7.79681 12.8955 8.52285 13.3134 8.97817L21.3461 17.4938L13.3134 26.0095C12.8955 26.4648 12.8955 27.2032 13.3134 27.6585C13.7429 28.1138 14.4394 28.1138 14.8689 27.6585L23.6793 18.3183C24.1088 17.863 24.1088 17.1247 23.6677 16.6694Z"
                fill="#56686F"
              />
            </svg>
          </div>
        </div>
      </GlimpseCard>

      <GlimpseCard
        title="Day in the Life"
        className="flex lg:hidden min-h-[416px]"
        subtitle=""
      >
        <div className="flex items-center justify-center h-[320px]">
          <GlimpseScrollCard
            image={daysInLifeInfo[pageNumber.dayInLife]?.image_url}
            title={daysInLifeInfo[pageNumber.dayInLife]?.title}
            subtitle={daysInLifeInfo[pageNumber.dayInLife]?.description}
          />
        </div>
        <div className="relative bottom-0 flex justify-between">
          <div
            className="absolute"
            hidden={pageNumber.dayInLife === 0}
            onClick={() => {
              setPageNumber((prevPageNumber: { dayInLife: number }) => ({
                ...prevPageNumber,
                dayInLife: prevPageNumber.dayInLife - 1,
              }))
            }}
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                transform="rotate(-180 17.5 17.5)"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3323 18.3306L20.1311 27.6585C20.5606 28.1138 21.2571 28.1138 21.6866 27.6585C22.1045 27.2032 22.1045 26.4771 21.6866 26.0218L13.6539 17.5062L21.6866 8.99048C22.1045 8.53516 22.1045 7.79681 21.6866 7.34149C21.2571 6.88617 20.5606 6.88617 20.1311 7.34149L11.3207 16.6817C10.8912 17.137 10.8912 17.8753 11.3323 18.3306Z"
                fill="#56686F"
              />
            </svg>
          </div>
          <div className="absolute right-[47%] top-2">
            {pageNumber.dayInLife + 1}/{daysInLifeInfo?.length}
          </div>
          <div
            className="absolute right-0"
            hidden={
              pageNumber.dayInLife === (daysInLifeInfo?.length as number) - 1
            }
            onClick={() => {
              setPageNumber((prevPageNumber: { dayInLife: number }) => ({
                ...prevPageNumber,
                dayInLife: prevPageNumber.dayInLife + 1,
              }))
              checkNextEnable(pageNumber.dayInLife >= 4 ? true : false)
            }}
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6677 16.6694L14.8689 7.34149C14.4394 6.88617 13.7429 6.88617 13.3134 7.34149C12.8955 7.79681 12.8955 8.52285 13.3134 8.97817L21.3461 17.4938L13.3134 26.0095C12.8955 26.4648 12.8955 27.2032 13.3134 27.6585C13.7429 28.1138 14.4394 28.1138 14.8689 27.6585L23.6793 18.3183C24.1088 17.863 24.1088 17.1247 23.6677 16.6694Z"
                fill="#56686F"
              />
            </svg>
          </div>
        </div>
      </GlimpseCard>
    </>
  )
}
export const DidYouKnowCard: React.FC<IDidYouKnowsCard> = ({
  didyouKnowsInfo,
  pageNumber,
  setPageNumber,
  flex,
  from,
  checkNextEnable,
  handleOpen,
}) => {
  useEffect(() => {
    if (window.innerWidth >= 768) {
      checkNextEnable(true)
    }
  }, [window.innerWidth])

  useEffect(() => {
    if (from === 'DeeperDive') checkNextEnable(true)
  }, [from])

  if (from === 'DeeperDive') {
    return (
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center pb-2 border-b border-[#C7C7C7] mb-6">
          <h2 className="text-4xl font-semibold leading-10 text-brand">
            Did You Know?
          </h2>
          <p className="text-sm font-normal leading-5 text-gray-dark max-w-[320px]">
            We put together some interesting facts about this career.{' '}
            <button
              type="button"
              className="cursor-pointer font-semibold text-primary"
              onClick={handleOpen}
            >
              View sources.
            </button>
          </p>
        </div>
        <div className="grid grid-cols-2 gap-x-8 gap-y-6 flex-1 content-center">
          {didyouKnowsInfo?.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center gap-1.5 h-[126px] max-w-[382px]"
            >
              <img
                src={item.icon_url}
                alt={item.title}
                className="w-[80px] h-[80px]"
              />
              <p className="text-sm font-normal leading-5 text-gray-dark text-center">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <>
      <GlimpseCard
        title="Did You Know?"
        className="hidden lg:flex "
        subtitleClass="text-sm mt-1"
        childrenClass="h-full flex flex-col justify-center "
        subtitle=""
      >
        <div
          className={`${
            flex
              ? 'justify-between px-[70px] pt-[40px] pb-[20px] flex w-full  '
              : 'grid grid-cols-2 justify-items-center gap-x-4 gap-y-2 sm:gap-x-6 md:gap-x-8 lg:gap-y-16 xl:gap-y-1'
          } `}
        >
          {didyouKnowsInfo?.map((items, index) => {
            return (
              <GlimpseScrollCard
                key={index}
                className="w-[164px] h-[158px] text-center flex  flex-col"
                image={items.icon_url}
                subtitle={items.title}
              />
            )
          })}
        </div>
      </GlimpseCard>

      <GlimpseCard
        title="Did You Know?"
        className="flex lg:hidden min-h-[416px] "
        childrenClass="relative "
        subtitle=""
        subtitleClass="text-[15px]"
      >
        <div className="flex items-center justify-center h-[320px]">
          <GlimpseScrollCard
            image={didyouKnowsInfo[pageNumber.didyouknow]?.icon_url}
            subtitle={didyouKnowsInfo[pageNumber.didyouknow]?.title}
          />
        </div>
        <div className="relative bottom-0 flex justify-between">
          <div
            className="absolute"
            hidden={pageNumber.didyouknow === 0}
            onClick={() =>
              setPageNumber((prevPageNumber: { didyouknow: number }) => ({
                ...prevPageNumber,
                didyouknow: prevPageNumber.didyouknow - 1,
              }))
            }
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                transform="rotate(-180 17.5 17.5)"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3323 18.3306L20.1311 27.6585C20.5606 28.1138 21.2571 28.1138 21.6866 27.6585C22.1045 27.2032 22.1045 26.4771 21.6866 26.0218L13.6539 17.5062L21.6866 8.99048C22.1045 8.53516 22.1045 7.79681 21.6866 7.34149C21.2571 6.88617 20.5606 6.88617 20.1311 7.34149L11.3207 16.6817C10.8912 17.137 10.8912 17.8753 11.3323 18.3306Z"
                fill="#56686F"
              />
            </svg>
          </div>
          <div className="absolute right-[47%] top-2">
            {pageNumber.didyouknow + 1}/{didyouKnowsInfo?.length}
          </div>
          <div
            className="absolute right-0"
            hidden={
              pageNumber.didyouknow === (didyouKnowsInfo?.length as number) - 1
            }
            onClick={() => {
              setPageNumber((prevPageNumber: { didyouknow: number }) => ({
                ...prevPageNumber,
                didyouknow: prevPageNumber.didyouknow + 1,
              }))
              checkNextEnable(pageNumber.didyouknow >= 2 ? true : false)
            }}
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6677 16.6694L14.8689 7.34149C14.4394 6.88617 13.7429 6.88617 13.3134 7.34149C12.8955 7.79681 12.8955 8.52285 13.3134 8.97817L21.3461 17.4938L13.3134 26.0095C12.8955 26.4648 12.8955 27.2032 13.3134 27.6585C13.7429 28.1138 14.4394 28.1138 14.8689 27.6585L23.6793 18.3183C24.1088 17.863 24.1088 17.1247 23.6677 16.6694Z"
                fill="#56686F"
              />
            </svg>
          </div>
        </div>
      </GlimpseCard>
    </>
  )
}
export const ProsConsCard: React.FC<IProsConsCard> = ({
  prosconsInfo,
  deeperDiveClass,
  from,
  pageNumber,
  setPageNumber,
  checkNextEnable,
}) => {
  useEffect(() => {
    if (window.innerWidth >= 768) {
      checkNextEnable(true)
    }
  }, [window.innerWidth])

  useEffect(() => {
    if (from === 'DeeperDive') checkNextEnable(true)
  }, [from])

  if (from === 'DeeperDive') {
    return (
      <CardLayout>
        <CardTitle
          title="Pros and Cons"
          subtitle="Every career comes with good and challenging parts."
        />
        <CardContent className="gap-10">
          <div>
            <h3 className="text-base font-bold text-gray-dark">
              Common advantages
            </h3>
            {prosconsInfo?.pros.map((item, index) => (
              <p
                key={index}
                className="text-sm font-normal leading-6 text-gray-dark"
              >
                {item.title}
              </p>
            ))}
          </div>
          <div>
            <h3 className="text-base font-bold text-gray-dark">
              Potential drawbacks
            </h3>
            {prosconsInfo?.cons.map((item, index) => (
              <p
                key={index}
                className="text-sm font-normal leading-6 text-gray-dark"
              >
                {item.title}
              </p>
            ))}
          </div>
        </CardContent>
      </CardLayout>
    )
  }

  return (
    <>
      <GlimpseCard
        title="Pros and Cons"
        className="items-center hidden lg:flex"
        childrenClass="flex h-full justify-center"
        subtitleClass="text-sm mt-1"
        subtitle=""
      >
        <div
          className={`grid grid-cols-1 gap-5 p-4 ${
            !deeperDiveClass ? 'xl:grid-cols-2' : ''
          } items-center`}
        >
          {deeperDiveClass ? (
            <div className="flex justify-between w-full gap-5 p-2 overflow-auto h-fit">
              <div
                className={`min-w-[250px] border-r-2 border-horizontalRow p-4 block`}
              >
                <div className="pb-4 text-base font-bold text-green">
                  Common Advantages
                </div>
                {prosconsInfo?.pros.map((items, index) => {
                  return (
                    <div key={index} className="flex flex-row">
                      <ul className="list-disc md:ml-5 list-item">
                        <li>{items.title}</li>
                      </ul>
                    </div>
                  )
                })}
              </div>
              <div className={`min-w-[250px] p-4 block`}>
                <div className="pb-4 text-base font-bold text-green">
                  Potential Drawbacks
                </div>
                {prosconsInfo?.cons.map((items, index) => {
                  return (
                    <div key={index} className="flex flex-row">
                      <ul className="list-disc md:ml-5 list-item">
                        <li className="appearance-none">{items.title}</li>
                      </ul>
                    </div>
                  )
                })}
              </div>
            </div>
          ) : (
            <>
              <div className={`xl:border-r-2 border-horizontalRow block pr-4`}>
                <div className="pb-4 text-base font-bold text-green">
                  Common Advantages
                </div>
                {prosconsInfo?.pros.map((items, index) => {
                  return (
                    <div key={index} className="flex flex-row">
                      <ul className="list-disc md:ml-5 list-item">
                        <li>{items.title}</li>
                      </ul>
                    </div>
                  )
                })}
              </div>
              <div className={`block`}>
                <div className="pb-4 text-base font-bold text-green">
                  Potential Drawbacks
                </div>
                {prosconsInfo?.cons.map((items, index) => {
                  return (
                    <div key={index} className="flex flex-row">
                      <ul className="list-disc md:ml-5 list-item">
                        <li>{items.title}</li>
                      </ul>
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>
      </GlimpseCard>

      <GlimpseCard
        title="Pros and Cons"
        className="flex lg:hidden min-h-[416px] "
        childrenClass="relative"
        subtitleClass="text-[14px]"
        subtitle=""
      >
        <div className="flex items-center justify-center h-[320px]">
          {pageNumber && pageNumber?.prosCons === 0 ? (
            <div className={`min-w-[250px] p-4 block`}>
              <div className="pb-4 text-base font-bold text-green">
                Common Advantages
              </div>
              {prosconsInfo?.pros.map((items, index) => {
                return (
                  <div key={index} className="flex flex-row">
                    <ul className="list-disc md:ml-5 list-item">
                      <li>{items.title}</li>
                    </ul>
                  </div>
                )
              })}
            </div>
          ) : null}
          {pageNumber && pageNumber?.prosCons === 1 ? (
            <div className={`min-w-[250px] p-4 block`}>
              <div className="pb-4 text-base font-bold text-green">
                Potential Drawbacks
              </div>
              {prosconsInfo?.cons.map((items, index) => {
                return (
                  <div key={index} className="flex flex-row">
                    <ul className="list-disc md:ml-5 list-item">
                      <li>{items.title}</li>
                    </ul>
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
        <div className="relative bottom-0 flex justify-between">
          <div
            className="absolute"
            hidden={pageNumber?.prosCons === 0}
            onClick={() =>
              setPageNumber((prevPageNumber: { prosCons: number }) => ({
                ...prevPageNumber,
                prosCons: prevPageNumber.prosCons - 1,
              }))
            }
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                transform="rotate(-180 17.5 17.5)"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3323 18.3306L20.1311 27.6585C20.5606 28.1138 21.2571 28.1138 21.6866 27.6585C22.1045 27.2032 22.1045 26.4771 21.6866 26.0218L13.6539 17.5062L21.6866 8.99048C22.1045 8.53516 22.1045 7.79681 21.6866 7.34149C21.2571 6.88617 20.5606 6.88617 20.1311 7.34149L11.3207 16.6817C10.8912 17.137 10.8912 17.8753 11.3323 18.3306Z"
                fill="#56686F"
              />
            </svg>
          </div>
          <div className="absolute right-[47%] top-2">
            {pageNumber?.prosCons ? pageNumber?.prosCons + 1 : 1}/2
          </div>
          <div
            className="absolute right-0"
            hidden={pageNumber?.prosCons === 1}
            onClick={() => {
              setPageNumber((prevPageNumber: { prosCons: number }) => ({
                ...prevPageNumber,
                prosCons: prevPageNumber.prosCons + 1,
              }))
              checkNextEnable(true)
            }}
          >
            <svg
              width={35}
              height={35}
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="17.5"
                cy="17.5"
                r="16.5"
                stroke="#56686F"
                strokeWidth={2}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6677 16.6694L14.8689 7.34149C14.4394 6.88617 13.7429 6.88617 13.3134 7.34149C12.8955 7.79681 12.8955 8.52285 13.3134 8.97817L21.3461 17.4938L13.3134 26.0095C12.8955 26.4648 12.8955 27.2032 13.3134 27.6585C13.7429 28.1138 14.4394 28.1138 14.8689 27.6585L23.6793 18.3183C24.1088 17.863 24.1088 17.1247 23.6677 16.6694Z"
                fill="#56686F"
              />
            </svg>
          </div>
        </div>
      </GlimpseCard>
    </>
  )
}
export const SalaryCard: React.FC<ISalary> = ({
  advance,
  median,
  starting,
  from,
  height = '300px',
  width = '350px',
  handleOpen,
}) => {
  const salaryLabel = [
    { class: 'Low', subclass: 'Starting' },
    { class: 'Median', subclass: '' },
    { class: 'High', subclass: 'Experienced' },
  ]
  const label = salaryLabel?.map((i: any) => {
    return [i.class, i.subclass ? `(${i.subclass})` : '']
  })

  const dataSet = {
    datasets: [
      {
        label: 'Salary',
        data: [starting, median, advance],
        backgroundColor: ['#D4B07D', '#F4CC94', '#FFD497'],
        borderRadius: { topLeft: 8, topRight: 8 },
      },
    ],
    labels: label,
  }

  if (from === 'DeeperDive') {
    return (
      <CardLayout>
        <CardTitle
          title="Salary"
          subtitle="These are average salary ranges in the U.S. These can vary based on experience and location."
        />
        <CardContent className="items-center">
          <div className="w-[333.5px] h-[333.5px] rounded border border-gray-light bg-white flex items-center justify-center p-6 shadow-subtle">
            <BarChart data={dataSet} key={'salaryChart'} salaryChart={true} />
          </div>
        </CardContent>
      </CardLayout>
    )
  }

  return (
    <GlimpseCard
      title="Salary"
      childrenClass="flex justify-center h-full items-center relative"
      subtitleClass="text-[14px] sm:text-sm "
      subtitle=""
    >
      <div
        className="flex items-center justify-center xl:pb-[70px]"
        style={{ height, width }}
      >
        <BarChart data={dataSet} key={'salaryChart'} salaryChart={true} />
      </div>
    </GlimpseCard>
  )
}

export const CareerTrendCard: React.FC<ICareerTrendCard> = ({
  careerTrendInfo,
  deeperDiveClass,
  from,
  handleOpen,
}) => {
  if (from === 'DeeperDive') {
    return (
      <CardLayout>
        <CardTitle
          title="Career Trends"
          subtitle="Understand current trends in the job market for this career."
        />
        <CardContent className="gap-8">
          {careerTrendInfo?.map((item, index) => (
            <div key={index}>
              <p className="text-4xl font-bold text-gray-dark">{item.title}</p>
              <p className="text-sm font-normal leading-5 text-gray-dark">
                {item.description}
              </p>
            </div>
          ))}
        </CardContent>
      </CardLayout>
    )
  }

  return (
    <GlimpseCard
      title="Career Trends"
      subtitle=""
      subtitleClass="text-[14px] sm:text-sm mt-1"
      childrenClass={` ${
        deeperDiveClass
          ? 'flex flex-col md:flex-row justify-center items-center gap-4 md:justify-around h-full p-[10px] relative md:items-center  flex-wrap'
          : ' flex flex-col md:flex-row xl:flex-col justify-center items-center gap-4 md:justify-around h-full p-[10px] relative md:items-center  xl:p-[50px] flex-wrap'
      }`}
    >
      {careerTrendInfo?.map((items, index) => {
        return (
          <div key={index}>
            <div className="text-center ">
              <GlimpseCareerTrends
                className="flex flex-col items-start"
                title={items.title}
                subtitle={items.description}
              />
            </div>
          </div>
        )
      })}
    </GlimpseCard>
  )
}
export const ImpactCard: React.FC<IImpactCard> = ({
  impactInfo,
  from,
  handleOpen,
}) => {
  if (from === 'DeeperDive') {
    return (
      <CardLayout>
        <CardTitle
          title="Impact On Others"
          subtitle="Why this career matters"
        />
        <CardContent className="gap-8">
          {impactInfo.map((item, index) => (
            <div key={index}>
              <p className="text-base font-semibold leading-5 text-gray-dark">
                "{item.description}"
              </p>
              <p className="text-base font-normal leading-5 text-gray-medium text-right mt-2">
                {item.author}
              </p>
            </div>
          ))}
        </CardContent>
      </CardLayout>
    )
  }

  return (
    <GlimpseCard
      title="Impact on Others"
      subtitle=""
      childrenClass="h-full"
      subtitleClass="text-sm mt-1"
      className="h-auto"
    >
      <div className="flex flex-col items-center justify-between h-full">
        <div className="flex flex-col justify-center gap-8 h-[90%] max-w-[500px]">
          {impactInfo.map((item, index) => {
            return (
              <GlimpseImpactCard
                key={index}
                impact={item.description}
                author={item.author}
              />
            )
          })}
        </div>
      </div>
    </GlimpseCard>
  )
}
export const Reprioritise: React.FC<IReprioritise> = ({ onNo, onYes }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h2 className="text-4xl font-semibold leading-10 text-brand mb-2">
        Reprioritize
      </h2>
      <p className="text-sm font-normal leading-5 text-gray-dark text-center max-w-[350px] mb-8">
        After learning about this career, do you want to reprioritize its
        ranking?
      </p>
      <div className="flex items-center gap-4">
        <Button variant="primary" onClick={onYes}>
          Yes
        </Button>
        <Button variant="outline" onClick={() => onNo(false)}>
          No
        </Button>
      </div>
    </div>
  )
}
export const GreatWork: React.FC<IGreatWork> = ({
  isQuizEnable,
  careerName,
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h2 className="text-4xl font-semibold leading-10 text-brand mb-2">
        Great Work!
      </h2>
      <p className="text-sm font-normal leading-5 text-gray-dark text-center max-w-[400px]">
        {isQuizEnable
          ? `Let’s review. Answer the following 3 questions correctly to complete the ${careerName} Deep Dive.`
          : `You’ve finished going through the module.`}
      </p>
    </div>
  )
}
export const Quizzes: React.FC<IDeeperDiveQuiz> = ({
  question,
  answers,
  currentSlide,
  answerChoosed,
}) => {
  const [hasError, setHasError] = useState<boolean | null>(null)

  return (
    <GlimpseCard title={`Question ${currentSlide}`} childrenClass="h-full">
      {question && (
        <>
          {hasError || hasError === null ? (
            <div className="flex flex-col gap-2 py-20 text-xl font-bold text-headerBlue ">
              {question}
              <div className="text-sm font-normal text-left">
                {answers.map((items: any, index: number) => {
                  return (
                    <ul key={index}>
                      <li
                        className={`p-2 m-2 border cursor-pointer rounded-xl itemsborder-gray`}
                      >
                        <input
                          type="radio"
                          aria-label="is_Correct"
                          id={question}
                          name={question}
                          // checked={items.is_correct}
                          className="checked:bg-green hover:checked:bg-green"
                          onChange={ev => {}}
                          onClick={() => {
                            setHasError(!items.is_correct)
                            answerChoosed(items)
                          }}
                        />
                        <span className="pl-2"> {items.answer}</span>
                      </li>
                    </ul>
                  )
                })}
                {hasError && (
                  <span className="pl-4 text-red">
                    That is the incorrect answer. Please try again.
                  </span>
                )}
              </div>
            </div>
          ) : (
            <>
              {currentSlide === 1 ? (
                <div className="flex flex-col items-center gap-2 py-20 font-bold text-headerBlue text-[36px] h-full justify-center">
                  Excellent!
                  <div className="text-sm font-normal text-center">
                    You really know your stuff.
                  </div>
                  <div>
                    <svg
                      width={90}
                      height={90}
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx={45} cy={45} r={45} fill="#529C82" />
                      <circle
                        cx="44.5881"
                        cy="44.5871"
                        r="36.3303"
                        fill="#6CBEA1"
                      />
                      <line
                        x1="26.8841"
                        y1="48.7158"
                        x2="35.5055"
                        y2="57.3372"
                        stroke="#F4EDDB"
                        strokeWidth={17}
                        strokeLinecap="round"
                      />
                      <line
                        x1="63.5781"
                        y1="33.4886"
                        x2="37.6173"
                        y2="59.4494"
                        stroke="#F4EDDB"
                        strokeWidth={17}
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                </div>
              ) : currentSlide === 2 ? (
                <div className="flex flex-col items-center gap-2 py-20 font-bold text-headerBlue text-[36px] h-full justify-center">
                  Nice Work!
                  <div className="text-sm font-normal text-center">
                    It's almost like you're already a pro.
                  </div>
                  <div>
                    <svg
                      width={90}
                      height={90}
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx={45} cy={45} r={45} fill="#529C82" />
                      <circle
                        cx="44.5881"
                        cy="44.5871"
                        r="36.3303"
                        fill="#6CBEA1"
                      />
                      <line
                        x1="26.8841"
                        y1="48.7158"
                        x2="35.5055"
                        y2="57.3372"
                        stroke="#F4EDDB"
                        strokeWidth={17}
                        strokeLinecap="round"
                      />
                      <line
                        x1="63.5781"
                        y1="33.4886"
                        x2="37.6173"
                        y2="59.4494"
                        stroke="#F4EDDB"
                        strokeWidth={17}
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center gap-2 py-20 font-bold text-headerBlue text-[36px] h-full justify-center">
                  Congrats!
                  <div className="text-sm font-normal text-center">
                    You got all three correct.
                  </div>
                  <div>
                    <svg
                      width={90}
                      height={90}
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx={45} cy={45} r={45} fill="#529C82" />
                      <circle
                        cx="44.5881"
                        cy="44.5871"
                        r="36.3303"
                        fill="#6CBEA1"
                      />
                      <line
                        x1="26.8841"
                        y1="48.7158"
                        x2="35.5055"
                        y2="57.3372"
                        stroke="#F4EDDB"
                        strokeWidth={17}
                        strokeLinecap="round"
                      />
                      <line
                        x1="63.5781"
                        y1="33.4886"
                        x2="37.6173"
                        y2="59.4494"
                        stroke="#F4EDDB"
                        strokeWidth={17}
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </GlimpseCard>
  )
}
